import { mediaInstance } from '@/api';

export const mediaService = {
    // User Documents (for users managing their own documents)
    getUserDocuments: (userId, params = {}) => {
        return mediaInstance.get(`/media/v1/users/${userId}/documents`, { params });
    },
    uploadUserDocument: (userId, file, documentType) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('document_type', documentType);
        return mediaInstance.post(`/media/v1/users/${userId}/documents`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    getUserDocumentUrl: (documentId) => {
        return mediaInstance.get(`/media/v1/users/documents/${documentId}/file`);
    },

    // Employee Documents (for users managing employee documents)
    getEmployeeDocuments: (employeeId, params = {}) => {
        return mediaInstance.get(`/media/v1/employees/${employeeId}/documents`, { params });
    },
    uploadEmployeeDocument: (employeeId, file, documentType) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('document_type', documentType);
        return mediaInstance.post(`/media/v1/employees/${employeeId}/documents`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    getEmployeeDocumentUrl: (documentId) => {
        return mediaInstance.get(`/media/v1/employees/documents/${documentId}/file`);
    },
    approveEmployeeDocument: (employeeId, documentId, pinCode) => {
        return mediaInstance.post(`/media/v1/employees/${employeeId}/documents/${documentId}/approve`, {
            pin_code: pinCode
        });
    },
    revokeEmployeeDocument: (employeeId, documentId) => {
        return mediaInstance.post(`/media/v1/employees/${employeeId}/documents/${documentId}/revoke`);
    },
    confirmRevokeEmployeeDocument: (employeeId, documentId, pinCode) => {
        return mediaInstance.post(`/media/v1/employees/${employeeId}/documents/${documentId}/revoke/confirm`, {
            pin_code: pinCode
        });
    },
    resendEmployeeDocumentPin: (employeeId, documentId) => {
        return mediaInstance.post(`/media/v1/employees/${employeeId}/documents/${documentId}/pin_code/resend`);
    },

    // Admin endpoints for managing user documents
    adminGetUserDocuments: (userId, params = {}) => {
        return mediaInstance.get(`/media/v1/admin/users/${userId}/documents`, { params });
    },
    adminUploadUserDocument: (userId, file, documentType, metadata = {}) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('document_type', documentType);
        Object.keys(metadata).forEach(key => {
            formData.append(key, metadata[key]);
        });
        return mediaInstance.post(`/media/v1/admin/users/${userId}/documents`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    // Admin endpoints for managing employee documents
    adminGetEmployeeDocuments: (employeeId, params = {}) => {
        return mediaInstance.get(`/media/v1/admin/employees/${employeeId}/documents`, { params });
    },
    adminUploadEmployeeDocument: (employeeId, file, documentType, metadata = {}) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('document_type', documentType);
        Object.keys(metadata).forEach(key => {
            formData.append(key, metadata[key]);
        });
        return mediaInstance.post(`/media/v1/admin/employees/${employeeId}/documents`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    // Admin document management
    adminDeleteDocument: (documentId) => {
        return mediaInstance.delete(`/media/v1/admin/documents/${documentId}`);
    },

    // Admin media link
    adminGetMediaLink: (mediaId) => {
        return mediaInstance.get(`/media/v1/admin/media/${mediaId}/link`);
    },

    // Admin signed document by message type and ID
    adminGetSignedDocumentByMessage: (messageType, messageId) => {
        return mediaInstance.get(`/media/v1/admin/documents/signed/${messageType}/${messageId}/url`);
    },

    // General Upload
    uploadMedia: (files, metadata = {}) => {
        const formData = new FormData();
        files.forEach(file => {
            formData.append('file', file);
        });
        Object.keys(metadata).forEach(key => {
            formData.append(key, metadata[key]);
        });
        return mediaInstance.post('/media/v1/uploads', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    getFileUrl: (mediaId) => {
        return mediaInstance.get(`/media/v1/link/${mediaId}`);
    }
}; 